/**
 * Axios Instance Configuration
 *
 * Base axios instance with interceptors for authentication.
 * This is the infrastructure layer - handles HTTP concerns.
 */
import axios from 'axios';
import { applyAuthSessionHeaders, endAuthSession, } from '@/domains/auth/services/auth-session.service';
// =============================================================================
// CONFIGURATION
// =============================================================================
/** Base URL from environment */
const BASE_URL = process.env.VUE_APP_API_URL || '';
// =============================================================================
// AXIOS INSTANCE
// =============================================================================
/**
 * Pre-configured axios instance with:
 * - Base URL from environment
 * - Bearer token injection
 * - Request/Response interceptors
 */
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});
// =============================================================================
// REQUEST INTERCEPTOR
// =============================================================================
api.interceptors.request.use(async (config) => {
    await applyAuthSessionHeaders(config);
    return config;
}, (error) => {
    return Promise.reject(error);
});
// =============================================================================
// RESPONSE INTERCEPTOR (optional, for global error handling)
// =============================================================================
api.interceptors.response.use((response) => response, async (error) => {
    if (error.response?.status === 401) {
        await endAuthSession();
    }
    return Promise.reject(error);
});
// =============================================================================
// EXPORTS
// =============================================================================
export default api;
/** Re-export for convenience */
export { api };
